import determineTarget from './determine-target';
import toggleElement from './toggle-element';

export default function setupSupernavMenus( header ) {
	if ( ! header ) {
		return () => null;
	}

	const navItems = header.querySelectorAll( '.menu-item-label, .menu-item-link' );
	const supernavMenus = document.querySelectorAll( '.nav-flyout' );

	supernavMenus.forEach( menu => {
		menu.setAttribute( 'aria-hidden', true );

		menu.addEventListener( 'toggle-on', event => {
			menu.dataset.trigger = event.detail?.source;

			supernavMenus.forEach( other => {
				if ( other.getAttribute( 'aria-hidden' ) === 'false' && other !== menu ) {
					toggleElement( other, false );
				}
			} );
		} );
	} );

	function closeAll( trigger ) {
		supernavMenus.forEach( menu => {
			if ( trigger && menu.dataset.trigger !== trigger ) {
				return;
			}
			if ( menu.getAttribute( 'aria-hidden' ) === 'false' ) {
				toggleElement( menu, false );
			}
		} );
	}

	navItems.forEach( item => {
		const target = determineTarget( item );
		if ( target?.classList.contains( 'nav-flyout' ) ) {
			return;
		}

		item.addEventListener( 'mouseenter', closeAll );
	} );

	document.addEventListener( 'click', event => {
		if ( ! event.target.closest( '.nav-flyout' ) && ! event.target.closest( '.menu-item-object-supernav_menu, .menu-item-type-navcolumn, .page-header__toggle' ) ) {
			closeAll();
		}
	} );

	document.addEventListener( 'mousemove', event => {
		if ( ! event.target.closest( '.page-header__inner, .nav-flyout' ) ) {
			closeAll( 'mouseenter' );
		}
	} );

	return closeAll;
}
